import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AssabilSalesRoutingModule } from './assabil-sales-routing.module';
import { AssabilSalesMenuComponent } from './assabil-sales-menu/assabil-sales-menu.component';
import { DanoneMslProductListComponent } from './components/sales-admin/danone_msl_product-list/danone_msl_product-list.component';
import { PromoListComponent } from './components/sales-admin/promo-list/promo-list.component';
import { PromoWidgetComponent } from './components/sales-admin/promo-widget/promo-widget.component';
import { PromoPartnerFamilyListComponent } from './components/sales-admin/promo-partner-family-list/promo-partner-family-list.component';
import { PromoPartnerFamilyLovComponent } from './components/sales-admin/promo-partner-family-lov/promo-partner-family-lov.component';
import { PromoProductFamilyListComponent } from './components/sales-admin/promo-product-family-list/promo-product-family-list.component';
import { PromoProductFamilyLovComponent } from './components/sales-admin/promo-product-family-lov/promo-product-family-lov.component';
import { SalesMonitoringWidgetComponent } from './components/sales-monitoring/sales-monitoring-widget/sales-monitoring-widget.component';
import { RoleKpisWidgetComponent } from './components/sales-monitoring/role-kpis-widget/role-kpis-widget.component';
import { PromoPipe } from './pipes/promo-pipe';
import { SalesMonitoringVisitPipe } from './pipes/sales-monitoring-visit-pipe';
import { AssabilAdminModule } from '../assabil-admin/assabil-admin.module';
import { MslPipe } from './pipes/msl-pipe';
import { DanoneDnProductFamilyListComponent } from './components/sales-admin/danone-dn-product-family-list/danone-dn-product-family-list.component';
import { DanoneDnProductFamilyWidgetComponent } from './components/sales-admin/danone-dn-product-family-widget/danone-dn-product-family-widget.component';
import { PromoPartnerFamilyWidgetComponent } from './components/sales-admin/promo-partner-family-widget/promo-partner-family-widget.component';
import { PromoProductFamilyWidgetComponent } from './components/sales-admin/promo-product-family-widget/promo-product-family-widget.component';
import { ProductOrFamilyModal } from './components/sales-admin/product-or-family-modal/product-or-family-modal.component';
import { ToolsModule } from '../tools/tools.module';
import { PromoSimulationComponent } from './components/sales-admin/promo-simulation/promo-simulation.component';
import { PromoLovComponent } from './components/sales-admin/promo-lov/promo-lov.component';
import { WarehouseTransferPipe } from './pipes/warehouse-transfer-pipe';
import { WarehouseTransferRequestPipe } from './pipes/warehouse-transfer-request-pipe';
import { PorderPipe } from './pipes/porder-pipe';
import { WarehouseTransferWidgetComponent } from './components/sales-branch/warehouse-transfer-widget/warehouse-transfer-widget.component';
import { WarehouseTransferListComponent } from './components/sales-branch/warehouse-transfer-list/warehouse-transfer-list.component';
import { RequestedAssignedComponent } from './components/sales-branch/requested-assigned/requested-assigned.component';
import { PorderWidgetComponent } from './components/sales-branch/porder-widget/porder-widget.component';
import { PorderListComponent } from './components/sales-branch/porder-list/porder-list.component';
import { WarehouseTransferTypeModal } from './components/sales-branch/warehouse-transfer-type-modal/warehouse-transfer-type-modal.component';
import { SettlementComponent } from './components/sales-branch/settlement/settlement.component';
import { WarehouseInventoryListComponent } from './components/sales-branch/warehouse-inventory-list/warehouse-inventory-list.component';
import { WarehouseInventoryWidgetComponent } from './components/sales-branch/warehouse-inventory-widget/warehouse-inventory-widget.component';
import { RoleProductQuotaComponent } from './components/sales-admin/role-product-quota/role-product-quota.component';
import { RoleProductRateComponent } from './components/sales-admin/role-product-rate/role-product-rate.component';
import { BranchInvoicingComponent } from './components/sales-branch/branch-invoicing/branch-invoicing.component';
import { WarehouseInOutComponent } from './components/sales-branch/warehouse-inout/warehouse-inout.component';
import { NgxGaugeModule } from 'ngx-gauge';
import { SorderListComponent } from './components/sales-branch/sorder-list/sorder-list.component';
import { SorderWidgetComponent } from './components/sales-branch/sorder-widget/sorder-widget.component';
import { SorderPipe } from './pipes/sorder-pipe';
import { PaymentListComponent } from './components/sales-branch/payment-list/payment-list.component';
import { PaymentWidgetModal } from './components/sales-branch/payment-widget/payment-widget.component';
import { DispatchComponent } from './components/sales-branch/dispatch/dispatch.component';
import { DanoneLoyaltyMonitoringWidgetComponent } from './components/sales-monitoring/danone-loyalty-monitoring-widget/danone-loyalty-monitoring-widget.component';
import { LoyaltyProgramKpiComponent } from './components/sales-monitoring/loyalty-program-kpi/loyalty-program-kpi.component';
import { LoyaltyProgramListComponent } from './components/sales-loyalty/loyalty-program-list/loyalty-program-list.component';
import { LoyaltyProgramLov } from './components/sales-loyalty/loyalty-program-lov/loyalty-program-lov.component';
import { LoyaltyProgramReleaseListComponent } from './components/sales-loyalty/loyalty-program-release-list/loyalty-program-release-list.component';
import { LoyaltyProgramReleaseWidgetComponent } from './components/sales-loyalty/loyalty-program-release-widget/loyalty-program-release-widget.component';
import { TargetTypeListComponent } from './components/sales-admin/target-type-list/target-type-list.component';
import { RoleTargetListComponent } from './components/sales-admin/role-target-list/role-target-list.component';
import { TargetTypeLovComponent } from './components/sales-admin/target-type-lov/target-type-lov.component';
import { TargetProductFamilyLovComponent } from './components/sales-admin/target-product-family-lov/target-product-family-lov.component';
import { LoyaltyPartnerListComponent } from './components/sales-loyalty/loyalty-partner-list/loyalty-partner-list.component';
import { DanoneLoyaltyQualityMonitoringWidgetComponent } from './components/sales-monitoring/danone-loyalty-quality-monitoring-widget/danone-loyalty-quality-monitoring-widget.component';
import { LoyaltyProgramQualityKpiComponent } from './components/sales-monitoring/loyalty-program-quality-kpi/loyalty-program-quality-kpi.component';
import { GeoAreaLoyaltyProgramKpiComponent } from './components/sales-monitoring/geo-area-loyalty-program-kpi/geo-area-loyalty-program-kpi.component';
import { GeoAreaLoyaltyProgramQualityKpiComponent } from './components/sales-monitoring/geo-area-loyalty-program-quality-kpi/geo-area-loyalty-program-quality-kpi.component';  
import { LoyaltyQualityPartnerListComponent } from './components/sales-loyalty/loyalty-quality-partner-list/loyalty-quality-partner-list.component';
import { DanoneLoyaltyBonusFollowupMonitoringWidgetComponent } from './components/sales-monitoring/danone-loyalty-bonus-followup-monitoring-widget/danone-loyalty-bonus-followup-monitoring-widget.component';
import { LoyaltyProgramBonusFollowupComponent } from './components/sales-monitoring/loyalty-program-bonus-followup/loyalty-program-bonus-followup.component';
import { GeoAreaLoyaltyProgramBonusFollowupComponent } from './components/sales-monitoring/geo-area-loyalty-program-bonus-followup/geo-area-loyalty-program-bonus-followup.component';
import { LoyaltyBonusFollowupPartnerListComponent } from './components/sales-loyalty/loyalty-bonus-followup-partner-list/loyalty-bonus-followup-partner-list.component';
import { RoleTargetMonitoringWidgetComponent } from './components/sales-monitoring/role-target-monitoring-widget/role-target-monitoring-widget.component';
import { RoleTargetKpisWidgetComponent } from './components/sales-monitoring/role-target-kpis-widget/role-target-kpis-widget.component';
import { ExcludedPartnerWidgetComponent } from './components/sales-monitoring/excluded-partner-widget/excluded-partner-widget.component';
import { GeoAreaExcludedPartnerComponent } from './components/sales-monitoring/geo-area-excluded-partner/geo-area-excluded-partner.component';
import { ExcludedPartnerComponent } from './components/sales-monitoring/excluded-partner/excluded-partner.component';
import { ExcludedPartnerListComponent } from './components/sales-loyalty/excluded-partner-list/excluded-partner-list.component';
import { MslMonitoringKpiComponent } from './components/sales-monitoring/msl-monitoring-kpi/msl-monitoring-kpi.component';
import { GeoAreaMslMonitoringKpiComponent } from './components/sales-monitoring/geo-area-msl-monitoring-kpi/geo-area-msl-monitoring-kpi.component';
import { DanoneMslMonitoringWidgetComponent } from './components/sales-monitoring/danone-msl-monitoring-widget/danone-msl-monitoring-widget.component';
import { SipKpiComponent } from './components/sales-monitoring/sip-kpi/sip-kpi.component';
import { GeoAreaSipKpiComponent } from './components/sales-monitoring/geo-area-sip-kpi/geo-area-sip-kpi.component';
import { DanoneSipMonitoringWidgetComponent } from './components/sales-monitoring/danone-sip-monitoring-widget/danone-sip-monitoring-widget.component';
import { SipPartnerListComponent } from './components/sales-loyalty/sip-partner-list/sip-partner-list.component';
import { MslRespectMonitoringKpiComponent } from './components/sales-monitoring/msl-respect-monitoring-kpi/msl-respect-monitoring-kpi.component';
import { GeoAreaMslRespectMonitoringKpiComponent } from './components/sales-monitoring/geo-area-msl-respect-monitoring-kpi/geo-area-msl-respect-monitoring-kpi.component';
import { DanoneMslRespectMonitoringWidgetComponent } from './components/sales-monitoring/danone-msl-respect-monitoring-widget/danone-msl-respect-monitoring-widget.component';
import { ServiceRateKpiComponent } from './components/sales-monitoring/service-rate-kpi/service-rate-kpi.component';
import { GeoAreaServiceRateKpiComponent } from './components/sales-monitoring/geo-area-service-rate-kpi/geo-area-service-rate-kpi.component';
import { DanoneServiceRateMonitoringWidgetComponent } from './components/sales-monitoring/danone-service-rate-monitoring-widget/danone-service-rate-monitoring-widget.component';

@NgModule({
  declarations: [
    AssabilSalesMenuComponent,
    DanoneMslProductListComponent,
    DanoneDnProductFamilyListComponent,
    DanoneDnProductFamilyWidgetComponent,
    PromoListComponent,
    PromoWidgetComponent,
    PromoPartnerFamilyListComponent,
    PromoPartnerFamilyWidgetComponent,
    PromoProductFamilyWidgetComponent,
    PromoPartnerFamilyLovComponent,
    PromoProductFamilyListComponent,
    PromoProductFamilyLovComponent,
    SalesMonitoringWidgetComponent,
    DanoneLoyaltyMonitoringWidgetComponent,
    DanoneLoyaltyQualityMonitoringWidgetComponent,
    RoleKpisWidgetComponent,
    PromoPipe,
    SalesMonitoringVisitPipe,
    MslPipe,
    WarehouseTransferPipe,
    PorderPipe,
    SorderPipe,
    WarehouseTransferRequestPipe,
    ProductOrFamilyModal,
    PromoSimulationComponent,
    PromoLovComponent,
    WarehouseTransferWidgetComponent,
    WarehouseTransferListComponent,
    RequestedAssignedComponent,
    PorderWidgetComponent,
    PorderListComponent,
    WarehouseTransferTypeModal,
    SettlementComponent,
    WarehouseInventoryListComponent,
    WarehouseInventoryWidgetComponent,
    RoleProductQuotaComponent,
    RoleProductRateComponent,
    BranchInvoicingComponent,
    WarehouseInOutComponent,
    SorderListComponent, 
    SorderWidgetComponent,
    PaymentListComponent,
    PaymentWidgetModal,
    DispatchComponent,
    LoyaltyProgramKpiComponent,
    LoyaltyProgramQualityKpiComponent,
    GeoAreaLoyaltyProgramKpiComponent,
    GeoAreaLoyaltyProgramQualityKpiComponent,
    LoyaltyProgramListComponent,
    LoyaltyProgramReleaseListComponent,
    LoyaltyProgramReleaseWidgetComponent,
    LoyaltyProgramLov,
    TargetTypeListComponent,
    RoleTargetListComponent,
    TargetTypeLovComponent,
    TargetProductFamilyLovComponent,
    LoyaltyPartnerListComponent,
    LoyaltyQualityPartnerListComponent,
    LoyaltyProgramBonusFollowupComponent,
    GeoAreaLoyaltyProgramBonusFollowupComponent,
    DanoneLoyaltyBonusFollowupMonitoringWidgetComponent,
    LoyaltyBonusFollowupPartnerListComponent,
    RoleTargetMonitoringWidgetComponent,
    RoleTargetKpisWidgetComponent,
    ExcludedPartnerWidgetComponent,
    GeoAreaExcludedPartnerComponent,
    ExcludedPartnerComponent,
    ExcludedPartnerListComponent,
    MslMonitoringKpiComponent,
    GeoAreaMslMonitoringKpiComponent,
    DanoneMslMonitoringWidgetComponent,
    SipKpiComponent,
    GeoAreaSipKpiComponent,
    DanoneSipMonitoringWidgetComponent,
    SipPartnerListComponent,
    MslRespectMonitoringKpiComponent,
    GeoAreaMslRespectMonitoringKpiComponent,
    DanoneMslRespectMonitoringWidgetComponent,
    ServiceRateKpiComponent,
    GeoAreaServiceRateKpiComponent,
    DanoneServiceRateMonitoringWidgetComponent,
  ],
  exports: [
    AssabilSalesMenuComponent,
  ],
  imports: [
    CommonModule,
    ToolsModule,
    AssabilAdminModule,
    AssabilSalesRoutingModule,
    NgxDatatableModule,
    NgxGaugeModule,
  ],
  
  entryComponents:[
    PromoPartnerFamilyLovComponent,
    PromoProductFamilyLovComponent,
    ProductOrFamilyModal,
    PromoLovComponent,
    WarehouseTransferTypeModal,
    PaymentWidgetModal,
    LoyaltyProgramLov,
    TargetTypeLovComponent,
    TargetProductFamilyLovComponent
  ]
})
export class AssabilSalesModule { }

